import { ApiUserRole } from '@/core/generated/api';

/** Варианты роли собеседника из приложения VOX */
export const chatCompanionRoles = [
    {
        id: null,
        name: 'Все'
    },
    {
        id: ApiUserRole.Client,
        name: 'Клиенты'
    },
    {
        id: ApiUserRole.Executor,
        name: 'Исполнители'
    },
];
